module.exports = __webpack_public_path__ + "img/banner1.61dd5159.png";